import { createFileRoute } from '@tanstack/react-router';

import { Oops } from '@/features/registration';

export const Route = createFileRoute('/oops')({
	component: () => <Oops />,
	head: () => ({
		meta: [
			{
				title: 'Oops, something went wrong | ACCESS Research Platform',
			},
		],
	}),
});
